interface MetaTag {
  name: string
  content: string
}

interface LinkTag {
  rel: string
  href: string
  as?: string
  crossOrigin?: string
  fetchPriority?: 'high' | 'low' | 'auto'
}

/** Mockup del hero — es el elemento LCP. Sincronizado con components/Hero.tsx. */
export const HERO_IMAGE_URL =
  'https://cdn.magicpatterns.com/uploads/84bHSstEKt3S7Lne1EoH4j/mOCKUP_HERO_LANDING.png'

const PAGE_TITLE = '100 New York Cookies para Fabricar y Vender — 2 tomos digitales'

const META_TAGS: MetaTag[] = [
  { name: 'facebook-domain-verification', content: 'vlgvuhfbincjf8k22klsbsto3ag0az' },
  {
    name: 'description',
    content:
      '100 recetas de New York Cookies gigantes, rellenas, clásicas y premium en 2 tomos digitales. Prepará desde casa, sumalas a tu catálogo y vendelas. Acceso inmediato por USD 8,99.',
  },
]

const LINK_TAGS: LinkTag[] = [
  // Warm up the font + image origins before the CSS/image requests are made.
  { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
  { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossOrigin: 'anonymous' },
  { rel: 'preconnect', href: 'https://cdn.magicpatterns.com' },
  // Discover the LCP image as early as possible, at high priority.
  { rel: 'preload', href: HERO_IMAGE_URL, as: 'image', fetchPriority: 'high' },
]

/**
 * Inserts global <meta> and resource-hint <link> tags into <head> once.
 * Existing tags are never duplicated.
 */
export function initHeadMeta(): void {
  if (typeof document === 'undefined') return

  document.title = PAGE_TITLE

  META_TAGS.forEach(({ name, content }) => {
    if (document.querySelector(`meta[name="${name}"]`)) return

    const meta = document.createElement('meta')
    meta.name = name
    meta.content = content
    document.head.appendChild(meta)
  })

  LINK_TAGS.forEach(({ rel, href, as, crossOrigin, fetchPriority }) => {
    if (document.querySelector(`link[rel="${rel}"][href="${href}"]`)) return

    const link = document.createElement('link')
    link.rel = rel
    link.href = href
    if (as) link.as = as
    if (crossOrigin) link.crossOrigin = crossOrigin
    if (fetchPriority) link.setAttribute('fetchpriority', fetchPriority)
    document.head.appendChild(link)
  })
}
